import { Config } from 'config/envConfig';
import { getUrl } from './getUrl';

export function loadPaymentScript(user, data) {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => {
        const options = {
            key: Config.RAZORPAY_API_KEY,
            amount: data.amount,
            currency: data.currency,
            order_id: data.order_id,
            name: 'Quyva Subscription',
            description: 'Quyva Pro Plan – 1 Month',
            callback_url: getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/payment-verification-order`
            ),
            prefill: { name: user.username, email: user.email },
            readonly: { email: true },
            notes: { email: user.email },
        };
        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    };
    script.onerror = () => {
        console.error('Razorpay script failed to load.');
    };
    document.body.appendChild(script);
}
